import DocumentEditor from "@/components/DocumentEditor";
export default function InvoiceEditor() {
  return <DocumentEditor kind="invoice" />;
}
